class MobileAccountLogin extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.updateMessage = this.updateMessage.bind(this)

    this.listeners.add(document, 'status:shopify:login', () =>
      this.updateMessage(),
    )

    this.updateRedirectUrl()
  }

  updateMessage () {
    this.welcomeMessage = window.theme.strings.welcomeBackCustomerName.replace('{{ first_name }}', window.StatusAccounts.customer.firstName)

    this.innerHTML = this.welcomeMessage
  }

  updateRedirectUrl () {
    if (localStorage.getItem('loggedInFromLocation') !== null) {
      const redirectLink = localStorage.getItem('loggedInFromLocation')

      if (this.externalEls['login-form'] && this.externalEls['login-form'].element) {
        this.externalEls['login-form'].element.querySelector('input[name="return_url"]').value = redirectLink
      }

      localStorage.setItem('openMinicartOnRedirect', redirectLink)
      localStorage.removeItem('loggedInFromLocation')
    }
  }
}

if (!customElements.get('mobile-account-login')) {
  customElements.define('mobile-account-login', MobileAccountLogin)
}
